import React from 'react';
import { Input } from './ui/input';

export function formatPhoneBR(digits) {
  const d = digits.replace(/\D/g, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

export default function PhoneInput({ value, onChange, ...rest }) {
  const formatted = formatPhoneBR(value || '');

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 11);
    onChange(digits);
  };

  return (
    <Input
      type="tel"
      inputMode="tel"
      autoComplete="off"
      value={formatted}
      onChange={handleChange}
      placeholder="(11) 98765-4321"
      {...rest}
    />
  );
}
